const uniqueCompanyNames = [
  'Global Refining Group',
  'Global Refining Group West',
  'Sibanye-Stillwater',
];

export { uniqueCompanyNames };
